import styled, { css } from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledPrivacyPolicy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.variables.sidebar_padding};
  overflow-y: scroll;
  height: calc(100% - ${theme.variables.sidebar_padding});
  font-family: ${theme.variables.font_family};

  & > div:first-child {
    position: absolute;
    top: ${theme.variables.sidebar_padding};
    left: ${theme.variables.sidebar_padding};
    z-index: 1;
  }
`;

export const StyledPage = styled.main`
  width: 100%;
  max-width: 860px;
  background: ${theme.colors.white};
  padding: 48px 56px;
  margin: 10px 0 40px;
  line-height: 1.6;

  @media (max-width: 620px) {
    padding: 24px 18px;
  }
`;

export const StyledDocHead = styled.header`
  border-bottom: 3px solid ${theme.colors.black};
  padding-bottom: 20px;
  margin-bottom: 32px;

  & h1 {
    color: ${theme.colors.black};
    margin: 0 0 4px;
    font-size: 2rem;
  }

  & .sub {
    color: #556;
    font-size: 1.05rem;
  }

  & .company {
    font-size: 0.85rem;
    color: #667;
    margin-top: 12px;
  }
`;

export const StyledSectionTitle = styled.h2`
  color: ${theme.colors.black};
  border-bottom: 1px solid ${theme.colors.purple_2};
  padding-bottom: 6px;
  margin-top: 42px;
  font-size: 1.4rem;
`;

export const StyledSubTitle = styled.h3`
  margin-top: 28px;
  font-size: 1.12rem;
`;

export const StyledMinorTitle = styled.h4`
  margin-top: 20px;
  font-size: 1rem;
`;

export const StyledParagraph = styled.p`
  margin: 12px 0;
`;

export const StyledList = styled.ul`
  margin: 12px 0;
  padding-left: 22px;

  & li {
    margin-bottom: 6px;
  }
`;

export const StyledLink = styled.a`
  color: ${theme.colors.purple};
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 18px 0;
  font-size: 0.92rem;

  & th,
  & td {
    border: 1px solid ${theme.colors.purple_2};
    padding: 8px 10px;
    text-align: left;
    vertical-align: top;
  }

  & th {
    background: ${theme.colors.purple};
    color: ${theme.colors.white};
    font-weight: 600;
  }

  & tbody tr:nth-child(even) td {
    background: ${theme.colors.purple_4};
  }

  &.meta-table td:first-child {
    font-weight: 600;
    width: 30%;
  }

  @media (max-width: 620px) {
    font-size: 0.82rem;
  }
`;

export const StyledSplitCell = styled.div<{ $centered?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ $centered }) =>
    $centered &&
    css`
      text-align: center;
    `}

  & .split-part {
    padding: 8px 10px;
  }

  & .split-part:first-child {
    border-bottom: 1px solid ${theme.colors.purple_2};
    ${({ $centered }) =>
      $centered &&
      css`
        font-style: italic;
      `}
  }
`;

export const StyledCallout = styled.div`
  background: ${theme.colors.purple_4};
  border-left: 4px solid ${theme.colors.purple};
  padding: 14px 18px;
  margin: 20px 0;
  border-radius: 0 6px 6px 0;

  & .label {
    font-weight: 700;
    color: ${theme.colors.purple};
    display: block;
    margin-bottom: 4px;
    text-transform: uppercase;
    font-size: 0.8rem;
    letter-spacing: 0.5px;
  }
`;

export const StyledDocFooter = styled.footer`
  margin-top: 48px;
  padding-top: 16px;
  border-top: 1px solid ${theme.colors.purple_2};
  font-size: 0.82rem;
  color: #778;
  text-align: center;
`;
